@if (themes !== null) {
  @if (hideTree && child) {
    @for (theme of themes; track theme; let themeIndex = $index) {
      <ng-container
        *ngTemplateOutlet="
          themeRow;
          context: { theme: theme, themeIndex: themeIndex }
        "
      ></ng-container>
    }
  } @else {
    <table
      class="w-100"
      [ngClass]="{ 'ggc-dt-theme': !hideTree, 'ggc-dt-theme--flat': hideTree }"
    >
      <tbody>
        @for (theme of themes; track theme; let themeIndex = $index) {
          @if (!hideTree && !(showOnlyDatasets && !child)) {
            <tr
              class="ggc-dt-btn-ts-collapse"
              [ngClass]="{
                'ggc-dt-btn-ts-active':
                  getActiveLayerCount(theme) > 0 || theme.open
              }"
              (click)="theme.open = !theme.open"
              (keydown.enter)="theme.open = !theme.open"
              tabindex="0"
            >
              @if (!iconAlignRight) {
                <td class="w-1">
                  @if (theme.open) {
                    <span
                      class="ggc-dt-expanded icons {{ iconExpanded }}"
                    ></span>
                  } @else {
                    <span
                      class="ggc-dt-collapsed icons {{ iconCollapsed }}"
                    ></span>
                  }
                </td>
              }
              <td [ngClass]="{ 'ggc-dt-btn-ls-active': theme.open }">
                {{ theme.themeName }} {{ generateCountString(theme) }}
              </td>
              @if (iconAlignRight) {
                <td class="w-1 text-end">
                  @if (theme.open) {
                    <span
                      class="ggc-dt-expanded icons {{ iconExpanded }}"
                    ></span>
                  } @else {
                    <span
                      class="ggc-dt-collapsed icons {{ iconCollapsed }}"
                    ></span>
                  }
                </td>
              }
            </tr>
          }
          @if (theme.open || hideTree || (showOnlyDatasets && !child)) {
            <ng-container
              *ngTemplateOutlet="
                themeRow;
                context: { theme: theme, themeIndex: themeIndex }
              "
            ></ng-container>
          }
        }
      </tbody>
    </table>
  }
}
<ng-template #themeRow let-theme="theme" let-themeIndex="themeIndex">
  @if (theme.themes !== undefined && theme.themes.length > 0) {
    <tr>
      <td [attr.colspan]="hideTree ? 1 : 2">
        <ggc-theme-selector
          [themes]="theme.themes"
          [themeNameIndex]="createNewIndex(themeIndex)"
          [showActiveCounters]="showActiveCounters"
          [iconCollapsed]="iconCollapsed"
          [iconExpanded]="iconExpanded"
          [iconAlignRight]="iconAlignRight"
          [iconDisabled]="iconDisabled"
          [iconChecked]="iconChecked"
          [iconUnchecked]="iconUnchecked"
          [iconInfoUrl]="iconInfoUrl"
          [hideTree]="hideTree"
          [layerLabelComponent]="layerLabelComponent"
          [datasetLabelComponent]="datasetLabelComponent"
          [expandTreeOnInit]="expandTreeOnInit"
          [child]="true"
          [layerEnabledCallback]="layerEnabledCallback"
          [mapIndex]="mapIndex"
          [viewerType]="viewerType"
        ></ggc-theme-selector>
      </td>
    </tr>
  }
  @if (theme.datasets !== undefined && theme.datasets.length > 0) {
    <tr>
      <td [attr.colspan]="hideTree || (showOnlyDatasets && !child) ? 1 : 2">
        <ggc-layer-selector
          [themeIndex]="createNewIndex(themeIndex)"
          [datasets]="theme.datasets"
          [showActiveCounters]="showActiveCounters"
          [iconCollapsed]="iconCollapsed"
          [iconExpanded]="iconExpanded"
          [iconAlignRight]="iconAlignRight"
          [iconDisabled]="iconDisabled"
          [iconChecked]="iconChecked"
          [iconUnchecked]="iconUnchecked"
          [iconInfoUrl]="iconInfoUrl"
          [hideTree]="hideTree"
          [layerLabelComponent]="layerLabelComponent"
          [datasetLabelComponent]="datasetLabelComponent"
          [expandTreeOnInit]="expandTreeOnInit"
          [layerEnabledCallback]="layerEnabledCallback"
          [mapIndex]="mapIndex"
          [viewerType]="viewerType"
        ></ggc-layer-selector>
      </td>
    </tr>
  }
</ng-template>
